<template>
  <div class="form-field form-field-text">
    <label :for="field.name">{{ label }}</label>

    <input
      :id="field.name"
      ref="input"
      v-model="fieldValue"
      :name="field.name"
      type="date"
      min="1900-01-01"
      @focus="blured = false"
      @blur="blured = true"
    />

    <FormErrorMessages :messages="feedback"></FormErrorMessages>
  </div>
</template>
<script setup lang="ts">
interface Props {
  field: FormField;
}

const input = ref();

const {
  formFieldsData: { memberValues },
  checkValidatedFormOnMounted,
} = inject(INJECT_FORM_PAGE);

const props = defineProps({
  field: null
});

const blured = ref<boolean>(false);
const fieldValue = computed({
  get() {
    return memberValues.value[props.field.name].value;
  },
  set(value) {
    memberValues.value[props.field.name].value = value;
  },
});

const label = computed(() => {
  return isFieldRequired(props.field)
    ? `${props.field.label}*`
    : props.field.label;
});

const { messages } = useFormFieldValidation(props.field, memberValues);

const feedback = computed(() => {
  let feedbackMessages = [''];
  if (blured.value && messages.value.length > 0) {
    feedbackMessages = [...messages.value];
  }
  return feedbackMessages;
});

onMounted(() => {
  if (checkValidatedFormOnMounted.value) blured.value = true;
});
</script>
<style lang="scss" scoped>
input {
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: stretch;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 5.2rem; // fix safari bug height for input date ::: TODO find a better way to fix this.
  appearance: none;
}
</style>
